// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2IJ-A","signatureButtonsRight":"ModalSign_signatureButtonsRight__eG1kq"};